// AUTO-GENERATED FILE — DO NOT EDIT. Run `bazel run settings-registry`.
//
// Regenerate with `bazel run settings-registry`.

import type { SettingsWrapperManifest } from "./settings-wrapper-manifest.types";

export const settingsWrapperManifest: SettingsWrapperManifest = {
  sections: [
    { id: "commentsold-coverage", file: "coverage/coverage.tsx" },
    {
      id: "commentsold-coverage",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
    },
    { id: "coverage.advanced_coverage", file: "coverage/coverage.tsx" },
    {
      id: "coverage.advanced_coverage",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
    },
    { id: "coverage.custom_logo", file: "coverage/custom-logo.tsx" },
    { id: "coverage.digital_warehouse", file: "coverage/coverage.tsx" },
    {
      id: "coverage.digital_warehouse",
      file: "returns/coverage/package-protection/digital-warehouse-rows.tsx",
    },
    { id: "coverage.display_options", file: "coverage/coverage.tsx" },
    {
      id: "coverage.display_options",
      file: "returns/coverage/display/display-section.tsx",
    },
    { id: "coverage.exclusions", file: "coverage/coverage.tsx" },
    { id: "coverage.general_coverage", file: "coverage/coverage.tsx" },
    { id: "coverage.info_modal", file: "coverage/info-modal.tsx" },
    {
      id: "coverage.package_protection",
      file: "returns/coverage/package-protection/package-protection-section.tsx",
    },
    { id: "coverage.pre_protected_orders", file: "coverage/coverage.tsx" },
    { id: "coverage.return_coverage", file: "coverage/coverage.tsx" },
    {
      id: "coverage.return_coverage",
      file: "returns/coverage/return-coverage/return-coverage-section.tsx",
    },
    {
      id: "customer_accounts_ad_blocks_edit.ad_blocks_edit",
      file: "customer-accounts/ad-blocks/ad-blocks-builder.tsx",
    },
    {
      id: "customer_accounts_ad_blocks.ad_blocks",
      file: "customer-accounts/ad-blocks/ad-blocks-drawer.tsx",
    },
    {
      id: "customer_accounts_storefront_display.native_accounts",
      file: "customer-accounts/storefront-displays.tsx",
    },
    {
      id: "customer_accounts_storefront_display.save_for_later",
      file: "customer-accounts/storefront-displays.tsx",
    },
    {
      id: "customer_portal_ab_test_analytics.overview",
      file: "return-flow/ab-test-analytics.tsx",
    },
    { id: "customer_portal_bundles.overview", file: "bundles/bundles.tsx" },
    {
      id: "customer_portal_flow_editors.overview",
      file: "flows/generic-flow-editor.tsx",
    },
    {
      id: "customer_portal.ai_exchange_agent",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.ai_exchange_agent",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
    },
    {
      id: "customer_portal.bundles",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.bundles",
      file: "returns/portal/bundles/bundles-section.tsx",
    },
    {
      id: "customer_portal.customer_options",
      file: "returns/portal/customer-options/customer-options-section.tsx",
    },
    {
      id: "customer_portal.customize",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.customize",
      file: "returns/portal/display-section.tsx",
    },
    {
      id: "customer_portal.discount_distribution",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.discount_distribution",
      file: "returns/portal/discount-distribution-section.tsx",
    },
    {
      id: "customer_portal.exchange_pricing",
      file: "returns/portal/pricing/pricing-section.tsx",
    },
    {
      id: "customer_portal.exchange_settings",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.exchange_settings",
      file: "returns/portal/exchange-ui/exchange-ui-section.tsx",
    },
    {
      id: "customer_portal.flows",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.localization",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.predefined_categories",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.predefined_categories",
      file: "returns/operations/processing/predefined-categories-rows.tsx",
    },
    {
      id: "customer_widget.appearance",
      file: "customer-widget/tabs/general-tab/display-rows.tsx",
    },
    {
      id: "customer_widget.setup",
      file: "customer-widget/tabs/general-tab/setup-rows.tsx",
    },
    { id: "display", file: "coverage/coverage.tsx" },
    { id: "dynamic-coverage-transform", file: "coverage/coverage.tsx" },
    {
      id: "dynamic-coverage-transform",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
    },
    {
      id: "exchange_agent_guidance.overview",
      file: "exchange-agent-guidance/exchange-agent-guidance-page.tsx",
    },
    { id: "fulfillment.address", file: "general.new.tsx" },
    { id: "fulfillment.auto_merge", file: "auto-merge-shipments.new.tsx" },
    { id: "fulfillment.auto_split", file: "auto-merge-shipments.new.tsx" },
    { id: "fulfillment.batch_suggestions", file: "general.new.tsx" },
    { id: "fulfillment.bundles", file: "general.new.tsx" },
    { id: "fulfillment.custom_field_mappings", file: "general.new.tsx" },
    { id: "fulfillment.custom_imports", file: "custom-import-schemas.tsx" },
    { id: "fulfillment.customer_notifications", file: "general.new.tsx" },
    { id: "fulfillment.dashboard", file: "warehouse-dashboard-settings.tsx" },
    { id: "fulfillment.display", file: "general.new.tsx" },
    { id: "fulfillment.general", file: "scanning-warehouse.new.tsx" },
    { id: "fulfillment.general", file: "scanning-warehouse.tsx" },
    {
      id: "fulfillment.import_restrictions",
      file: "restrictions/restrictions-page.tsx",
    },
    { id: "fulfillment.international_shipping", file: "international.new.tsx" },
    {
      id: "fulfillment.merge_exceptions",
      file: "auto-merge-shipments.new.tsx",
    },
    { id: "fulfillment.merge_outcomes", file: "auto-merge-shipments.new.tsx" },
    {
      id: "fulfillment.merge_suggestions",
      file: "auto-merge-shipments.new.tsx",
    },
    {
      id: "fulfillment.outbound_notifications",
      file: "notification/tabs/outbound-labels-notifications-tab.tsx",
    },
    { id: "fulfillment.package_photos", file: "general.new.tsx" },
    { id: "fulfillment.pick_sessions", file: "scanning-warehouse.new.tsx" },
    { id: "fulfillment.pick_sessions", file: "scanning-warehouse.tsx" },
    { id: "fulfillment.print_actions", file: "printing.new.tsx" },
    { id: "fulfillment.print_profiles", file: "printing.new.tsx" },
    { id: "fulfillment.printers", file: "printing.new.tsx" },
    { id: "fulfillment.printing", file: "printing.new.tsx" },
    { id: "fulfillment.printing", file: "printing.tsx" },
    { id: "fulfillment.remember_shipment_choices", file: "general.new.tsx" },
    { id: "fulfillment.replenishment", file: "scanning-warehouse.new.tsx" },
    { id: "fulfillment.replenishment", file: "scanning-warehouse.tsx" },
    { id: "fulfillment.return_label_defaults", file: "general.new.tsx" },
    { id: "fulfillment.safeguards", file: "general.new.tsx" },
    {
      id: "fulfillment.scan_to_verify",
      file: "scan-to-verify-settings-drawer.tsx",
    },
    { id: "fulfillment.security.authorized_devices", file: "security.tsx" },
    { id: "fulfillment.security.pin_sign_in", file: "security.tsx" },
    { id: "fulfillment.ship_from_locations", file: "general.tsx" },
    { id: "fulfillment.ship_from_locations", file: "locations-settings.tsx" },
    {
      id: "fulfillment.split_exceptions",
      file: "auto-merge-shipments.new.tsx",
    },
    { id: "fulfillment.split_outcomes", file: "auto-merge-shipments.new.tsx" },
    {
      id: "fulfillment.split_sku_mappings",
      file: "auto-merge-shipments.new.tsx",
    },
    { id: "fulfillment.tax_identifiers", file: "international.new.tsx" },
    { id: "fulfillment.transfers", file: "scanning-warehouse.new.tsx" },
    { id: "fulfillment.transfers", file: "scanning-warehouse.tsx" },
    { id: "fulfillment.work_orders", file: "scanning-warehouse.new.tsx" },
    { id: "fulfillment.work_orders", file: "scanning-warehouse.tsx" },
    { id: "hsa.buy_buttons", file: "conversion/hsa/hsa-settings-page.tsx" },
    {
      id: "integrations.linnworks",
      file: "linnworks-returns-settings-form.tsx",
    },
    {
      id: "integrations.netsuite",
      file: "netsuite-settings/sections/credit-memos-section.tsx",
    },
    {
      id: "integrations.netsuite",
      file: "netsuite-settings/sections/return-authorizations-section.tsx",
    },
    {
      id: "integrations.netsuite",
      file: "netsuite-settings/sections/transactions-section.tsx",
    },
    {
      id: "integrations.teamwork-commerce",
      file: "teamwork-commerce-settings/teamwork-commerce-processing-section.tsx",
    },
    {
      id: "international_markets_editor.market_editor",
      file: "markets/editor/market-editor-form.tsx",
    },
    {
      id: "international_markets_editor.market_editor",
      file: "markets/market-editor-page.tsx",
    },
    { id: "international_markets.markets", file: "markets/markets-page.tsx" },
    {
      id: "international_returns.customs_csv_import",
      file: "international/components/import-international-customs-csv-form.tsx",
    },
    {
      id: "international_returns.customs_delay_notifications",
      file: "international/components/customs-delay-notification-section.tsx",
    },
    {
      id: "international_returns.customs_metafields",
      file: "international/components/international-metafields-form.tsx",
    },
    {
      id: "international_returns.missing_customs_review",
      file: "international/components/missing-customs-review-section.tsx",
    },
    {
      id: "international_returns.redo_assisted_customs",
      file: "international/components/product-catalog-readiness-card.tsx",
    },
    {
      id: "international_returns.tax_ids",
      file: "international/components/store-setup-section.tsx",
    },
    {
      id: "inventory_general.adjustment_reasons",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_general.product_merging",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_general.reserved_inventory_buckets",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_purchase_orders.purchase_orders",
      file: "inventory-management/purchase-order-settings.tsx",
    },
    {
      id: "inventory_purchase_orders.recommendation_urgencies",
      file: "inventory-management/purchase-order-settings.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.account_mapping",
      file: "inventory-management/quickbooks-account-mapping.new.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.account_mapping",
      file: "inventory-management/quickbooks-account-mapping.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.location_mapping",
      file: "inventory-management/quickbooks-account-mapping.new.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.location_mapping",
      file: "inventory-management/quickbooks-account-mapping.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_connection",
      file: "inventory-management/quickbooks-integration-settings.new.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_connection",
      file: "inventory-management/quickbooks-integration-settings.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_sync_settings",
      file: "inventory-management/quickbooks-integration-settings.new.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_sync_settings",
      file: "inventory-management/quickbooks-integration-settings.tsx",
    },
    {
      id: "order_editing.editing_rules",
      file: "order-editing/order-editing-settings.tsx",
    },
    {
      id: "order_editing.subscription_editing",
      file: "order-editing/order-editing-settings.tsx",
    },
    {
      id: "order_tracking_settings.carrier_mappings",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "order_tracking_settings.checkout_delivery_estimates",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "order_tracking_settings.general",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "order_tracking_settings.weekly_email",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "portal_builder.overview",
      file: "customer-portal-builder/customer-portal-builder-settings.tsx",
    },
    {
      id: "products_attributes_by_owner.attribute_definitions_by_owner",
      file: "attribute-definitions/attribute-definitions-page.tsx",
    },
    {
      id: "products_attributes.attribute_definitions",
      file: "attribute-definitions/attribute-definitions-landing-page.tsx",
    },
    { id: "products_general.hazmat", file: "product/product.tsx" },
    {
      id: "products_general.product_transform",
      file: "product/product-transform.tsx",
    },
    { id: "redo-item-fulfillment", file: "coverage/coverage.tsx" },
    {
      id: "returns_billing_general.subscription",
      file: "billing/products/returns/returns-billing.tsx",
    },
    {
      id: "returns.advanced_processing",
      file: "automation/processing/advanced-processing-flows-section.tsx",
    },
    {
      id: "returns.advanced_processing",
      file: "returns/operations/processing/processing-section.tsx",
    },
    {
      id: "returns.automation_agent_review",
      file: "automation/agent-review-card.tsx",
    },
    {
      id: "returns.automation_agent_review",
      file: "returns/operations/processing/agent-review-rows.tsx",
    },
    {
      id: "returns.automation_claim_processing",
      file: "automation/processing/claim-processing-section.tsx",
    },
    {
      id: "returns.automation_claim_processing",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
    },
    {
      id: "returns.automation_code_functions",
      file: "automation/code-functions-section.tsx",
    },
    {
      id: "returns.automation_code_functions",
      file: "returns/operations/processing/code-functions-rows.tsx",
    },
    {
      id: "returns.automation_dropoff_processing",
      file: "automation/processing/dropoff-auto-processing-section.tsx",
    },
    {
      id: "returns.automation_dropoff_processing",
      file: "returns/operations/processing/dropoff-auto-processing-rows.tsx",
    },
    {
      id: "returns.automation_general",
      file: "automation/general-settings-card.tsx",
    },
    {
      id: "returns.automation_green_returns",
      file: "automation/processing/green-returns-section.tsx",
    },
    {
      id: "returns.automation_green_returns",
      file: "returns/operations/processing/green-returns-rows.tsx",
    },
    {
      id: "returns.automation_inventory",
      file: "automation/inventory-card.tsx",
    },
    {
      id: "returns.automation_inventory",
      file: "returns/operations/inventory/inventory-section.tsx",
    },
    {
      id: "returns.automation_label_expiration",
      file: "automation/label-expiration-card.tsx",
    },
    {
      id: "returns.automation_label_expiration",
      file: "returns/labels/label-expiration-section.tsx",
    },
    {
      id: "returns.automation_label_expiration",
      file: "returns/shopper-notifications/email-notifications/reminder-rows.tsx",
    },
    {
      id: "returns.automation_merchant_created",
      file: "automation/inventory-card.tsx",
    },
    {
      id: "returns.automation_merchant_created",
      file: "returns/operations/merchant-created-returns/merchant-created-returns-section.tsx",
    },
    {
      id: "returns.automation_return_processing",
      file: "automation/processing/return-processing-section.tsx",
    },
    {
      id: "returns.automation_return_processing",
      file: "returns/operations/processing-events/return-processing-section.tsx",
    },
    {
      id: "returns.automation_shopify",
      file: "automation/shopify-settings-card.tsx",
    },
    {
      id: "returns.automation_shopify",
      file: "returns/operations/ecommerce/shopify/shopify-settings-section.tsx",
    },
    {
      id: "returns.exchanges_fulfillment",
      file: "exchanges/cards/fulfillment-card.tsx",
    },
    {
      id: "returns.exchanges_fulfillment",
      file: "returns/operations/processing/out-of-stock-rows.tsx",
    },
    {
      id: "returns.exchanges_fulfillment_regions",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
    },
    {
      id: "returns.exchanges_fulfillment_regions",
      file: "returns/operations/orders/orders-section.tsx",
    },
    {
      id: "returns.exchanges_order_notes",
      file: "exchanges/cards/exchange-notes-card.tsx",
    },
    {
      id: "returns.exchanges_order_notes",
      file: "returns/operations/orders/orders-section.tsx",
    },
    {
      id: "returns.exchanges_order_pricing",
      file: "exchange/exchange-financial-strategy-section.tsx",
    },
    {
      id: "returns.exchanges_order_pricing",
      file: "returns/operations/orders/orders-section.tsx",
    },
    { id: "returns.exchanges_orders", file: "exchanges/cards/order-card.tsx" },
    {
      id: "returns.exchanges_orders",
      file: "returns/operations/orders/orders-section.tsx",
    },
    {
      id: "returns.exchanges_shipping_name",
      file: "exchanges/cards/exchange-shipping-card.tsx",
    },
    {
      id: "returns.flow_labels",
      file: "returns/labels/labels-flow/labels-flow-section.tsx",
    },
    {
      id: "returns.flow_location",
      file: "returns/locations/locations-flow-section.tsx",
    },
    {
      id: "returns.managed_returns_processing_flow",
      file: "returns/warehouse/processing-section.tsx",
    },
    { id: "returns.permissions", file: "permissions/permissions.tsx" },
    {
      id: "returns.permissions",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
    },
    {
      id: "returns.policies_workflows",
      file: "returns/policies/workflows-section.tsx",
    },
    { id: "returns.pos", file: "point-of-sale/general-section.tsx" },
    {
      id: "returns.pos",
      file: "returns/operations/point-of-sale/point-of-sale-section.tsx",
    },
    {
      id: "returns.pos_integration_locations",
      file: "point-of-sale/integration-locations-page.tsx",
    },
    { id: "returns.processing", file: "processing.tsx" },
    {
      id: "returns.processing",
      file: "returns/operations/processing/store-credit-rows.tsx",
    },
    {
      id: "returns.shipping_dropoff_providers",
      file: "returns/locations/dropoff-providers-section.tsx",
    },
    {
      id: "returns.shipping_dropoff_providers",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_label_combination",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "returns/labels/label-builder/label-builder-section.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "returns/labels/packing-slip/packing-slip-builder-section.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "returns/portal/shipping-options-section.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_return_locations",
      file: "returns/locations/return-locations/return-locations-section.tsx",
    },
    {
      id: "returns.shipping_return_locations",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.ui_barcodes",
      file: "returns/labels/label-builder/barcode-rows.tsx",
    },
    {
      id: "returns.ui_barcodes",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.ui_external_ra_number",
      file: "returns-ui/external-ra-number-card.tsx",
    },
    {
      id: "returns.ui_gift_receipts",
      file: "returns-ui/gift-receipts-card.tsx",
    },
    {
      id: "returns.ui_gift_receipts",
      file: "returns/portal/gift-returns/gift-returns-section.tsx",
    },
    {
      id: "returns.ui_item_disposition",
      file: "returns-ui/item-disposition-card.tsx",
    },
    {
      id: "returns.ui_return_details",
      file: "returns-ui/return-details-card.tsx",
    },
    {
      id: "returns.ui_return_details",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
    },
    {
      id: "returns.ui_return_editing",
      file: "returns-ui/return-editing-card.tsx",
    },
    {
      id: "returns.ui_return_editing",
      file: "returns/portal/return-editing-section.tsx",
    },
    {
      id: "returns.warehouse_grade_actions",
      file: "managed-returns/returns-centers-index.tsx",
    },
    {
      id: "returns.warehouse_grade_actions",
      file: "returns/warehouse/grade-actions/grade-actions-section.tsx",
    },
    {
      id: "returns.withdrawals_auto_cancellation",
      file: "withdrawals/withdrawals-auto-cancellation-section.tsx",
    },
    {
      id: "returns.withdrawals_exclusions",
      file: "withdrawals/withdrawals-exclusions-section.tsx",
    },
    {
      id: "returns.withdrawals_general",
      file: "withdrawals/withdrawals-general-section.tsx",
    },
    {
      id: "returns.withdrawals_notifications",
      file: "withdrawals/withdrawals-notifications-section.tsx",
    },
    { id: "sales-channels", file: "coverage/coverage.tsx" },
    {
      id: "sales-channels",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "shipping_carriers.carriers",
      file: "carrier-accounts/carriers-page.tsx",
    },
    { id: "shipping_cross_border.cross_border", file: "cross-border.tsx" },
    { id: "shipping_discounts.free_shipping_codes", file: "discounts.tsx" },
    {
      id: "shipping_freight.freight_delivery_accessorials",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_handling_units",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_pickup_accessorials",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_pickup_windows",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_fulfillment_promise.fulfillment_cutoff",
      file: "fulfillment-cutoff/fulfillment-cutoff-page.tsx",
    },
    {
      id: "shipping_fulfillment_promise.fulfillment_cutoff",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.new.tsx",
    },
    {
      id: "shipping_fulfillment_promise.promise_days",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.new.tsx",
    },
    { id: "shopify-cart-validation", file: "coverage/coverage.tsx" },
    {
      id: "shopify-cart-validation",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
    },
    {
      id: "support.ai",
      file: "ai-agent/components/general-ai-support-tab.tsx",
    },
    {
      id: "support.ai_channels",
      file: "ai-agent/components/general-ai-support-tab.tsx",
    },
    {
      id: "support.csat",
      file: "customer-satisfaction/csat-settings-shell.tsx",
    },
    {
      id: "support.live_chat_widget",
      file: "customer-widget/tabs/support-tab.tsx",
    },
    { id: "support.tags", file: "conversation-tags/tags.tsx" },
    { id: "support.ticket_routing", file: "general.tsx" },
    {
      id: "warranty_registration_rewards.discount",
      file: "registration-rewards.tsx",
    },
    {
      id: "warranty_registration.purchase_channels",
      file: "registration-settings.tsx",
    },
    {
      id: "warranty_registration.registration_collections",
      file: "registration-settings.tsx",
    },
  ],
  settings: [
    {
      id: "bulkReturnsEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "cart-validation-function",
      file: "coverage/coverage.tsx",
      sectionId: "shopify-cart-validation",
    },
    {
      id: "cart-validation-function",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
      sectionId: "shopify-cart-validation",
    },
    { id: "channel-selector", file: "coverage/sales-channels-card.tsx" },
    { id: "checkboxFontSize", file: "coverage/coverage.tsx" },
    {
      id: "checkboxFontSize",
      file: "returns/coverage/display/advanced-display-rows.tsx",
    },
    { id: "checkboxSelector", file: "coverage/coverage.tsx" },
    {
      id: "checkboxSelector",
      file: "returns/coverage/display/advanced-display-rows.tsx",
    },
    {
      id: "checkoutDeliveryEstimates/enabled",
      file: "order-tracking/order-tracking-settings.tsx",
      sectionId: "order_tracking_settings.checkout_delivery_estimates",
    },
    {
      id: "checkoutOptimization/fulfillmentCutoffSchedule",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.new.tsx",
      sectionId: "shipping_fulfillment_promise.fulfillment_cutoff",
    },
    {
      id: "checkoutOptimization/fulfillmentCutoffSchedule",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.tsx",
    },
    { id: "checkoutSelector", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "checkoutSelector",
      file: "returns/portal/exchange-ui/selection-rows.tsx",
    },
    { id: "color", file: "coverage/coverage.tsx" },
    { id: "color", file: "returns/coverage/display/advanced-display-rows.tsx" },
    { id: "coverage", file: "coverage/coverage.tsx" },
    {
      id: "coverage",
      file: "returns/coverage/return-coverage/covered-methods-rows.tsx",
    },
    {
      id: "coverage-builder",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    { id: "coverageExcludeCentEnding", file: "coverage/coverage.tsx" },
    {
      id: "coverageExcludeCentEnding",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
    },
    { id: "coverageExcludeCollections", file: "coverage/coverage.tsx" },
    {
      id: "coverageExcludeCollections",
      file: "returns/coverage/return-coverage/exclusion-rows.tsx",
    },
    {
      id: "coverageExcludeCustomerTags",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeCustomerTags",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "coverageExcludeDiscountCodes",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeDiscountCodes",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    { id: "coverageExcludeProductTags", file: "coverage/coverage.tsx" },
    {
      id: "coverageExcludeProductTags",
      file: "returns/coverage/return-coverage/exclusion-rows.tsx",
    },
    {
      id: "coverageExcludeProperties",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeProperties",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "coverageExcludeSources",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeSources",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "coverageExcludeTags",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeTags",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    { id: "custom-logo", file: "coverage/coverage.tsx", sectionId: "display" },
    {
      id: "custom-logo",
      file: "returns/coverage/display/builder-links-rows.tsx",
    },
    {
      id: "customerAccounts/nativeAccounts/overrideAccountLinks",
      file: "customer-accounts/native-accounts.tsx",
    },
    {
      id: "customerAccounts/nativeAccounts/redirectFromAccountsPages",
      file: "customer-accounts/native-accounts.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/anchorLocation",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/enabled",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/message",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/numViewedProductsUntilPanelOpen",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/title",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerWidget/general/hideWidgetAfterHours",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customerWidget/general/showCustomerWidgetInReturnApp",
      file: "customer-widget/tabs/general-tab/setup-rows.tsx",
      sectionId: "customer_widget.setup",
    },
    {
      id: "customerWidget/general/widgetColor",
      file: "customer-widget/tabs/general-tab/display-rows.tsx",
      sectionId: "customer_widget.appearance",
    },
    {
      id: "customerWidget/support/messagingHeadingText",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customsAugmentation/artifactId",
      file: "customs/customs-settings-section.tsx",
    },
    {
      id: "customsAugmentation/metafieldKeys/product",
      file: "customs/customs-settings-section.tsx",
    },
    {
      id: "customsAugmentation/metafieldKeys/variant",
      file: "customs/customs-settings-section.tsx",
    },
    {
      id: "discountCodePartialMatch",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "discountCodePartialMatch",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "discountDistributionMethod",
      file: "customer-portal/discount-distribution-settings.tsx",
    },
    {
      id: "discountDistributionMethod",
      file: "returns/portal/discount-distribution-section.tsx",
      sectionId: "customer_portal.discount_distribution",
    },
    {
      id: "dynamic-coverage-transform-function",
      file: "coverage/coverage.tsx",
    },
    {
      id: "dynamic-coverage-transform-function",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
      sectionId: "dynamic-coverage-transform",
    },
    {
      id: "exchangeAgent/displayExchangeValueAsDiscount",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/displayExchangeValueAsDiscount",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeAgent/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/enabled",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeAgent/productRecommendations/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/enabled",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeAgent/productRecommendations/limit",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/limit",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeAgent/productRecommendations/tagExclusionRules",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/tagExclusionRules",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeAgent/variantRecommendations/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/variantRecommendations/enabled",
      file: "returns/portal/ai-exchange-agent/ai-exchange-agent-section.tsx",
      sectionId: "customer_portal.ai_exchange_agent",
    },
    {
      id: "exchangeBannerColor",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerColor",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    {
      id: "exchangeBannerCustomCss",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerCustomCss",
      file: "returns/portal/exchange-ui/advanced-exchange-ui-rows.tsx",
    },
    { id: "exchangeBannerFont", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "exchangeBannerFont",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    {
      id: "exchangeBannerFontColor",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerFontColor",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    {
      id: "exchangeBannerShowDoneButton",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerShowDoneButton",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    { id: "exchangeBannerText", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "exchangeBannerText",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    { id: "exchangeGroups", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "exchangeGroups",
      file: "returns/portal/exchange-ui/advanced-exchange-ui-rows.tsx",
    },
    {
      id: "exchanges/advancedExchanges",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/advancedExchanges",
      file: "returns/portal/customer-options/exchange-eligibility-rows.tsx",
    },
    {
      id: "exchanges/allowCustomerDiscountCodes",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/allowCustomerDiscountCodes",
      file: "returns/portal/pricing/variant-pricing-rows.tsx",
    },
    {
      id: "exchanges/allowInstant",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/allowInstant",
      file: "returns/portal/customer-options/instant-exchange-rows.tsx",
    },
    {
      id: "exchanges/applyAutomaticDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/applyAutomaticDiscounts",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/applyOriginalOrderDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/applyOriginalOrderDiscounts",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/differentPricedVariantExchanges",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/differentPricedVariantExchanges",
      file: "returns/portal/pricing/variant-pricing-rows.tsx",
    },
    {
      id: "exchanges/exchangeOptionsPreviewShowOriginalPrice",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/exchangeOptionsPreviewShowOriginalPrice",
      file: "returns/portal/exchange-ui/selection-rows.tsx",
    },
    {
      id: "exchanges/excludeDifferentPriceVariants",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeDifferentPriceVariants",
      file: "returns/portal/pricing/variant-pricing-rows.tsx",
    },
    {
      id: "exchanges/excludeProductMetafields",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeProductMetafields",
      file: "returns/portal/customer-options/exchange-eligibility-rows.tsx",
    },
    {
      id: "exchanges/excludeProductSkus",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeProductSkus",
      file: "returns/portal/customer-options/exchange-eligibility-rows.tsx",
    },
    {
      id: "exchanges/excludeProductTags",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeProductTags",
      file: "returns/portal/customer-options/exchange-eligibility-rows.tsx",
    },
    {
      id: "exchanges/excludeVariantMetafields",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeVariantMetafields",
      file: "returns/portal/customer-options/exchange-eligibility-rows.tsx",
    },
    {
      id: "exchanges/hideOutOfStockVariants",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/hideOutOfStockVariants",
      file: "returns/portal/customer-options/advanced-customer-options-rows.tsx",
    },
    {
      id: "exchanges/hideUnpublishedVariants",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/hideUnpublishedVariants",
      file: "returns/portal/customer-options/advanced-customer-options-rows.tsx",
    },
    {
      id: "exchanges/instantExchangeOnly",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantExchangeOnly",
      file: "returns/portal/customer-options/instant-exchange-rows.tsx",
    },
    {
      id: "exchanges/instantExpirationDays",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantExpirationDays",
      file: "returns/portal/customer-options/instant-exchange-rows.tsx",
    },
    {
      id: "exchanges/instantHoldAmount",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantHoldAmount",
      file: "returns/portal/customer-options/instant-exchange-rows.tsx",
    },
    {
      id: "exchanges/reapplyCompareAtDiscount",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/reapplyCompareAtDiscount",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/recreateAutomaticDiscountsAsCodes",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/recreateAutomaticDiscountsAsCodes",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/recreateExpiredDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/recreateExpiredDiscounts",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/selection",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/selection",
      file: "returns/portal/exchange-ui/selection-rows.tsx",
    },
    {
      id: "exchanges/shopSiteURL",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/shopSiteURL",
      file: "returns/portal/exchange-ui/selection-rows.tsx",
    },
    {
      id: "exchanges/shopSiteUseCartDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/shopSiteUseCartDiscounts",
      file: "returns/portal/pricing/discount-method-rows.tsx",
    },
    {
      id: "exchanges/variantExchangeProductTags",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/variantExchangeProductTags",
      file: "returns/portal/pricing/variant-pricing-rows.tsx",
    },
    {
      id: "exchanges/variantPickerColorHexMetafield",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/variantPickerColorHexMetafield",
      file: "returns/portal/exchange-ui/advanced-exchange-ui-rows.tsx",
    },
    { id: "final-sale-subtext", file: "coverage/coverage.tsx" },
    {
      id: "final-sale-subtext",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
      sectionId: "commentsold-coverage",
    },
    { id: "final-sale-title-text", file: "coverage/coverage.tsx" },
    {
      id: "final-sale-title-text",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
      sectionId: "commentsold-coverage",
    },
    {
      id: "hideCheckbox",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.general_coverage",
    },
    {
      id: "hideCheckbox",
      file: "returns/coverage/display/advanced-display-rows.tsx",
    },
    {
      id: "hsa/buyButtons/showOnlyHsaPaymentMethod",
      file: "conversion/hsa/hsa-settings-page.tsx",
      sectionId: "hsa.buy_buttons",
    },
    { id: "html", file: "coverage/coverage.tsx" },
    { id: "html", file: "returns/coverage/display/advanced-display-rows.tsx" },
    {
      id: "ims/purchaseOrderDefaultCcEmails",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.purchase_orders",
    },
    {
      id: "ims/purchaseOrderDefaultLocationId",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.purchase_orders",
    },
    {
      id: "ims/purchaseOrderRecommendationUrgencies",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.recommendation_urgencies",
    },
    { id: "info-modal", file: "coverage/coverage.tsx", sectionId: "display" },
    {
      id: "infoModal/cartIconEnabled",
      file: "coverage/info-modal-settings.tsx",
    },
    {
      id: "infoModal/checkoutIconEnabled",
      file: "coverage/info-modal-settings.tsx",
    },
    { id: "infoModal/customCss", file: "coverage/info-modal-settings.tsx" },
    {
      id: "infoModal/enableTopLayerModalApi",
      file: "coverage/info-modal-settings.tsx",
    },
    { id: "infoModal/headerText", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/logo", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/sideImage", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/subheaderText", file: "coverage/info-modal-settings.tsx" },
    {
      id: "internationalMarketsEditor/marketEditor/pricingMode",
      file: "markets/editor/market-editor-form.tsx",
      sectionId: "international_markets_editor.market_editor",
    },
    {
      id: "inventory/minimum_stock",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "inventory/minimum_stock",
      file: "returns/portal/customer-options/advanced-customer-options-rows.tsx",
    },
    {
      id: "labelExpiration/compensationMethodsToRemind",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/compensationMethodsToRemind",
      file: "returns/shopper-notifications/email-notifications/reminder-rows.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/days",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/days",
      file: "returns/labels/label-expiration-section.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/expirationEmails",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/flagReturnWhenReopened",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/flagReturnWhenReopened",
      file: "returns/labels/label-expiration-section.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reminderEmailDays",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reminderEmailDays",
      file: "returns/shopper-notifications/email-notifications/reminder-rows.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reminderEmails",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reopenReturnAfterDays",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reopenReturnAfterDays",
      file: "returns/labels/label-expiration-section.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/shouldReopenReturnWhenLabelUsed",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/shouldReopenReturnWhenLabelUsed",
      file: "returns/labels/label-expiration-section.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/strategy",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/strategy",
      file: "returns/labels/label-expiration-section.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "landedCost/purchaseLabelsOutsideOms",
      file: "components/lcg-outside-oms-card.tsx",
    },
    {
      id: "linnworks/returns/defaultLocation",
      file: "linnworks-returns-settings-form.tsx",
      sectionId: "integrations.linnworks",
    },
    {
      id: "linnworks/returns/enabled",
      file: "linnworks-returns-settings-form.tsx",
      sectionId: "integrations.linnworks",
    },
    {
      id: "linnworks/returns/locationMappings",
      file: "linnworks-returns-settings-form.tsx",
      sectionId: "integrations.linnworks",
    },
    {
      id: "linnworks/returns/processReturnsEnabled",
      file: "linnworks-returns-settings-form.tsx",
      sectionId: "integrations.linnworks",
    },
    {
      id: "localization/enabled",
      file: "customer-portal/localization-settings.tsx",
    },
    {
      id: "localization/enabled",
      file: "returns/portal/display-section.tsx",
      sectionId: "customer_portal.customize",
    },
    {
      id: "netsuite/customerRefund/customFields",
      file: "netsuite-settings/sections/credit-memos-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/exchangeOrder/customerDepositAccountId",
      file: "netsuite-settings/sections/transactions-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/exchangeOrder/customerDepositPaymentMethodId",
      file: "netsuite-settings/sections/transactions-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/exchangeOrder/discountItemId",
      file: "netsuite-settings/sections/transactions-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/exchangeOrder/returnValueApplication",
      file: "netsuite-settings/sections/transactions-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/returnAuthorization/sourcePriority",
      file: "netsuite-settings/sections/return-authorizations-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "netsuite/useDiscountLocationId",
      file: "netsuite-settings/sections/transactions-section.tsx",
      sectionId: "integrations.netsuite",
    },
    {
      id: "orderEditing/subscriptionEditing/address",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/cancel",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/enabled",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/frequency",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/nextDate",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/quantity",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/subscriptionEditing/skip",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.subscription_editing",
    },
    {
      id: "orderEditing/tools/cancelOrder/restockInventory",
      file: "order-editing/order-editing-rules.tsx",
    },
    {
      id: "orderEditing/tools/updateOrder/changeVariantRestockInventory",
      file: "order-editing/order-editing-rules.tsx",
    },
    {
      id: "orderEditing/tools/updateOrder/removeItemRestockInventory",
      file: "order-editing/order-editing-rules.tsx",
    },
    {
      id: "orderEditing/updateShippingPriceOnOrderEdit",
      file: "order-editing/order-editing-settings.tsx",
      sectionId: "order_editing.editing_rules",
    },
    {
      id: "orderTracking/carrierMappings",
      file: "order-tracking/order-tracking-settings.tsx",
      sectionId: "order_tracking_settings.carrier_mappings",
    },
    {
      id: "orderTracking/stalledDays",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/stalledDaysFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/textRules",
      file: "order-tracking/order-tracking-settings.tsx",
      sectionId: "order_tracking_settings.general",
    },
    {
      id: "orderTracking/v2/excludeSaturdayFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSaturdayTransit",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSundayFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSundayTransit",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/orderExclusionRules",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/weeklyAnalyticsEmail/enabled",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/weeklyAnalyticsEmail/recipientEmails",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "outboundLabels/address/addressOutreachAutomation",
      file: "general.new.tsx",
      sectionId: "fulfillment.customer_notifications",
    },
    {
      id: "outboundLabels/address/addressVerificationCcEmail",
      file: "general.new.tsx",
      sectionId: "fulfillment.customer_notifications",
    },
    {
      id: "outboundLabels/address/addressVerificationReplyToEmail",
      file: "general.new.tsx",
      sectionId: "fulfillment.customer_notifications",
    },
    {
      id: "outboundLabels/address/autoCleanAddresses",
      file: "general.new.tsx",
      sectionId: "fulfillment.address",
    },
    {
      id: "outboundLabels/address/autoPlaceHoldOnAddressVerificationFailure",
      file: "general.new.tsx",
      sectionId: "fulfillment.address",
    },
    {
      id: "outboundLabels/address/autoPlaceHoldOnAddressVerificationFailureDurationDays",
      file: "general.new.tsx",
      sectionId: "fulfillment.address",
    },
    {
      id: "outboundLabels/address/enableAddressComparison",
      file: "general.new.tsx",
      sectionId: "fulfillment.address",
    },
    {
      id: "outboundLabels/address/internationalAddressOutreach",
      file: "general.new.tsx",
      sectionId: "fulfillment.address",
    },
    {
      id: "outboundLabels/address/internationalAddressOutreach",
      file: "general.tsx",
    },
    {
      id: "outboundLabels/autoMerge/addNote/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_outcomes",
    },
    {
      id: "outboundLabels/autoMerge/addTags/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_outcomes",
    },
    {
      id: "outboundLabels/autoMerge/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.auto_merge",
    },
    {
      id: "outboundLabels/autoMerge/exceptionConditions",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_exceptions",
    },
    {
      id: "outboundLabels/autoMerge/mergeConditions",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.auto_merge",
    },
    {
      id: "outboundLabels/autoMerge/refundOtherShippingOptions",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_outcomes",
    },
    {
      id: "outboundLabels/autoMerge/serviceLevelPriority",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_outcomes",
    },
    {
      id: "outboundLabels/autoSplit/addTags/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.split_outcomes",
    },
    {
      id: "outboundLabels/autoSplit/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.auto_split",
    },
    {
      id: "outboundLabels/autoSplit/exceptionConditions/orderTags",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.split_exceptions",
    },
    {
      id: "outboundLabels/autoSplit/leaveOne",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.split_outcomes",
    },
    {
      id: "outboundLabels/autoSplit/productMappings",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.split_sku_mappings",
    },
    {
      id: "outboundLabels/autoSplit/splitConditions",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.auto_split",
    },
    {
      id: "outboundLabels/autoSplit/splitIntoIndividualShipments",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.split_outcomes",
    },
    {
      id: "outboundLabels/batchSuggestions/groupingKey",
      file: "general.new.tsx",
      sectionId: "fulfillment.batch_suggestions",
    },
    {
      id: "outboundLabels/batchSuggestions/minGroupCount",
      file: "general.new.tsx",
      sectionId: "fulfillment.batch_suggestions",
    },
    {
      id: "outboundLabels/batchSuggestions/statusOption",
      file: "general.new.tsx",
      sectionId: "fulfillment.batch_suggestions",
    },
    {
      id: "outboundLabels/billOfMaterials/alwaysExpandBomIgnoreInventory",
      file: "general.new.tsx",
      sectionId: "fulfillment.bundles",
    },
    {
      id: "outboundLabels/billOfMaterials/alwaysHideInputItems",
      file: "general.new.tsx",
      sectionId: "fulfillment.bundles",
    },
    {
      id: "outboundLabels/billOfMaterials/showBomInputsInGroupTable",
      file: "general.new.tsx",
      sectionId: "fulfillment.bundles",
    },
    {
      id: "outboundLabels/blockPrintingBeyondInventory",
      file: "general.new.tsx",
      sectionId: "fulfillment.safeguards",
    },
    {
      id: "outboundLabels/carrierAccountDisabledServiceLevels",
      file: "carrier-accounts/merchant-carriers.tsx",
    },
    {
      id: "outboundLabels/customMetadata",
      file: "general.new.tsx",
      sectionId: "fulfillment.custom_field_mappings",
    },
    {
      id: "outboundLabels/customs",
      file: "international.new.tsx",
      sectionId: "fulfillment.international_shipping",
    },
    {
      id: "outboundLabels/defaultActionButton",
      file: "printing.new.tsx",
      sectionId: "fulfillment.print_actions",
    },
    {
      id: "outboundLabels/defaultOneClickPrintBatchSize",
      file: "printing.new.tsx",
      sectionId: "fulfillment.print_actions",
    },
    {
      id: "outboundLabels/defaultShipFromLocationExternalId",
      file: "general.tsx",
      sectionId: "fulfillment.ship_from_locations",
    },
    {
      id: "outboundLabels/defaultShipFromLocationExternalId",
      file: "locations-settings.tsx",
      sectionId: "fulfillment.ship_from_locations",
    },
    {
      id: "outboundLabels/degroupItemsByCustomAttributes",
      file: "general.new.tsx",
      sectionId: "fulfillment.display",
    },
    {
      id: "outboundLabels/disabledRedoServiceLevels",
      file: "carrier-accounts/redo-carriers.tsx",
    },
    {
      id: "outboundLabels/disableKeyboardOnScan",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/documents",
      file: "printing.new.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/documents/packingSlip/perParcelSlips",
      file: "printing.new.tsx",
    },
    {
      id: "outboundLabels/documents/packingSlip/perParcelSlips",
      file: "printing.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/documents/pickList/emphasizeQuantity",
      file: "printing.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/documents/pickList/perOrder",
      file: "printing.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/documents/shippingLabel/customSectionEnabled",
      file: "printing.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/fulfillmentPromiseDays",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.new.tsx",
      sectionId: "shipping_fulfillment_promise.promise_days",
    },
    {
      id: "outboundLabels/fulfillmentPromiseDays",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.tsx",
    },
    {
      id: "outboundLabels/hideUnderscoreCustomAttributes",
      file: "general.new.tsx",
      sectionId: "fulfillment.display",
    },
    {
      id: "outboundLabels/internalNotifications/notifyOnCarrierConnectionInterrupted",
      file: "notification/tabs/outbound-labels-notifications-tab.tsx",
      sectionId: "fulfillment.outbound_notifications",
    },
    {
      id: "outboundLabels/learnedPresets/parcel",
      file: "general.new.tsx",
      sectionId: "fulfillment.remember_shipment_choices",
    },
    {
      id: "outboundLabels/learnedPresets/weight",
      file: "general.new.tsx",
      sectionId: "fulfillment.remember_shipment_choices",
    },
    {
      id: "outboundLabels/liveViewCountsEnabled",
      file: "general.new.tsx",
      sectionId: "fulfillment.display",
    },
    {
      id: "outboundLabels/pinChecks/enabled",
      file: "general.new.tsx",
      sectionId: "fulfillment.safeguards",
    },
    {
      id: "outboundLabels/preferredReturnLabelCarrier",
      file: "general.new.tsx",
      sectionId: "fulfillment.return_label_defaults",
    },
    {
      id: "outboundLabels/preferredReturnLabelService",
      file: "general.new.tsx",
      sectionId: "fulfillment.return_label_defaults",
    },
    {
      id: "outboundLabels/rejectUnknownItemsFromPicks",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/rejectUnknownItemsFromPicks",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/scanVerify/autoVerifyLabeledOrders",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/scanVerify/labelAutoPrintTrigger",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/scanVerify/manualQuantityEntry",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/scanVerify/moveScannedItemToTop",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/scanVerify/moveVerifiedItemsToBottom",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/sendPickupEmailOnOverride",
      file: "general.new.tsx",
      sectionId: "fulfillment.customer_notifications",
    },
    {
      id: "outboundLabels/suggestMerge/enabled",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_suggestions",
    },
    {
      id: "outboundLabels/suggestMerge/mergeConditions",
      file: "auto-merge-shipments.new.tsx",
      sectionId: "fulfillment.merge_suggestions",
    },
    {
      id: "outboundLabels/variantReceivedKey",
      file: "general.new.tsx",
      sectionId: "fulfillment.custom_field_mappings",
    },
    {
      id: "outboundLabels/variantReceivedNamespace",
      file: "general.new.tsx",
      sectionId: "fulfillment.custom_field_mappings",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/autoCapture/armDelayMs",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/autoCapture/countdownMs",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/autoCapture/enabled",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/autoCapture/motionThreshold",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/enabled",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/maxCount",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/verifyParcelPhotos/minCount",
      file: "general.new.tsx",
      sectionId: "fulfillment.package_photos",
    },
    {
      id: "outboundLabels/weightFormat",
      file: "general.new.tsx",
      sectionId: "fulfillment.display",
    },
    {
      id: "outboundLabels/wms/barcodeLabelSize",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.work_orders",
    },
    {
      id: "outboundLabels/wms/barcodeLabelSize",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.work_orders",
    },
    {
      id: "outboundLabels/wms/binNaming",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.general",
    },
    {
      id: "outboundLabels/wms/binNaming",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.general",
    },
    {
      id: "outboundLabels/wms/bulkPickSession",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.work_orders",
    },
    {
      id: "outboundLabels/wms/bulkPickSession",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.work_orders",
    },
    {
      id: "outboundLabels/wms/dashboard",
      file: "warehouse-dashboard-settings.tsx",
      sectionId: "fulfillment.dashboard",
    },
    {
      id: "outboundLabels/wms/defaultFulfillmentLocationExternalId",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.general",
    },
    {
      id: "outboundLabels/wms/defaultFulfillmentLocationExternalId",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.general",
    },
    {
      id: "outboundLabels/wms/defaultReplenishmentQuantity",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.replenishment",
    },
    {
      id: "outboundLabels/wms/defaultReplenishmentQuantity",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.replenishment",
    },
    {
      id: "outboundLabels/wms/emptyInventoryLevelCleanup",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/emptyInventoryLevelCleanup",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/excludeEmptyTransferDestinations",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/excludeEmptyTransferDestinations",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/hideManualToteAssignment",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/hideManualToteAssignment",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/lotTracking",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/lotTracking",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/pickSession/allowPaymentPendingPicks",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/allowPaymentPendingPicks",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/defaultOrderCount",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/defaultOrderCount",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/forceSingleItemPickSessions",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/forceSingleItemPickSessions",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/maxItemCount",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/maxItemCount",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/sameBinSortMode",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/sameBinSortMode",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/scanOncePerProduct",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/scanOncePerProduct",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/scanType",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/scanType",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/stalePickedRelease",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/stalePickedRelease",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/zonePickingMode",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/pickSession/zonePickingMode",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/preferFullPickTitle",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/preferFullPickTitle",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/preferRedoBinsOverMarketplace",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/preferRedoBinsOverMarketplace",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/receivingMode",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/receivingMode",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/showOrderNotesInPickSession",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/showOrderNotesInPickSession",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.pick_sessions",
    },
    {
      id: "outboundLabels/wms/transferPutawayOrder",
      file: "scanning-warehouse.new.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "outboundLabels/wms/transferPutawayOrder",
      file: "scanning-warehouse.tsx",
      sectionId: "fulfillment.transfers",
    },
    {
      id: "portalExcludedCollections",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "portalExcludedProductIds",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "portalExcludedProductTags",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "pos/allowPOSAdjustments",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/allowPOSAdjustments",
      file: "returns/operations/point-of-sale/point-of-sale-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/allowPOSManualDiscounts",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/allowPOSManualDiscounts",
      file: "returns/operations/point-of-sale/point-of-sale-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/defaultPosRestock",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/defaultPosRestock",
      file: "returns/operations/point-of-sale/point-of-sale-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/externalLocationMappings",
      file: "point-of-sale/integration-locations-page.tsx",
      sectionId: "returns.pos_integration_locations",
    },
    {
      id: "pos/sendOnlyCompletionEmail",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/sendOnlyCompletionEmail",
      file: "returns/operations/point-of-sale/point-of-sale-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "preProtectedOrdersEnabled",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.pre_protected_orders",
    },
    {
      id: "preProtectedOrdersEnabled",
      file: "returns/coverage/package-protection/advanced-package-protection-rows.tsx",
    },
    {
      id: "products/hazmat/lithiumBattery/tagsInclude",
      file: "product/hazmat.tsx",
    },
    {
      id: "publicapi/couponedItemsDiscountThreshold",
      file: "coverage/coverage.tsx",
    },
    {
      id: "publicapi/couponedItemsDiscountThreshold",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
    },
    {
      id: "publicapi/coverageExcludeLocalPickup",
      file: "coverage/coverage.tsx",
    },
    {
      id: "publicapi/coverageExcludeLocalPickup",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
    },
    { id: "publicapi/discountsAreFinalSales", file: "coverage/coverage.tsx" },
    {
      id: "publicapi/discountsAreFinalSales",
      file: "returns/coverage/return-coverage/commentsold-rows.tsx",
    },
    {
      id: "redo-item-fulfillment",
      file: "coverage/coverage.tsx",
      sectionId: "redo-item-fulfillment",
    },
    {
      id: "redo-item-fulfillment",
      file: "returns/coverage/package-protection/advanced-package-protection-rows.tsx",
    },
    {
      id: "returns/advancedProcessing/compensationEnabled",
      file: "automation/processing/advanced-processing-flows-section.tsx",
      sectionId: "returns.advanced_processing",
    },
    {
      id: "returns/advancedProcessing/compensationEnabled",
      file: "returns/operations/processing/processing-flows-rows.tsx",
    },
    {
      id: "returns/advancedProcessing/restockingEnabled",
      file: "automation/processing/advanced-processing-flows-section.tsx",
      sectionId: "returns.advanced_processing",
    },
    {
      id: "returns/advancedProcessing/restockingEnabled",
      file: "returns/operations/processing/processing-flows-rows.tsx",
    },
    {
      id: "returns/aiReturnReasons/predefinedCategories",
      file: "customer-portal/predefined-categories-settings.tsx",
    },
    {
      id: "returns/aiReturnReasons/predefinedCategories",
      file: "returns/operations/processing/predefined-categories-rows.tsx",
      sectionId: "customer_portal.predefined_categories",
    },
    {
      id: "returns/aiReturnReasons/usePredefinedCategories",
      file: "customer-portal/predefined-categories-settings.tsx",
    },
    {
      id: "returns/aiReturnReasons/usePredefinedCategories",
      file: "returns/operations/processing/predefined-categories-rows.tsx",
      sectionId: "customer_portal.predefined_categories",
    },
    {
      id: "returns/automation/addReturnTagToOriginalOrder",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/addReturnTagToOriginalOrder",
      file: "returns/operations/processing/general-rows.tsx",
    },
    {
      id: "returns/automation/agentReviewRiskConfigs",
      file: "automation/agent-review-card.tsx",
      sectionId: "returns.automation_agent_review",
    },
    {
      id: "returns/automation/agentReviewRiskConfigs",
      file: "returns/operations/processing/agent-review-rows.tsx",
      sectionId: "returns.automation_agent_review",
    },
    {
      id: "returns/automation/autoProcessGreenReturnTypes",
      file: "automation/processing/green-returns-section.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/autoProcessGreenReturnTypes",
      file: "returns/operations/processing/green-returns-rows.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/autoProcessMerchantCreatedGreenReturnTypes",
      file: "automation/processing/green-returns-section.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/autoProcessMerchantCreatedGreenReturnTypes",
      file: "returns/operations/processing/green-returns-rows.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/claimProcessing/exchange",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/exchange",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/exchangeDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/exchangeDelay",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refund",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refund",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refundDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refundDelay",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCredit",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCredit",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCreditDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCreditDelay",
      file: "returns/operations/processing-events/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/defaultReimburseOriginalShipping",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/defaultReimburseOriginalShipping",
      file: "returns/operations/processing/general-rows.tsx",
    },
    {
      id: "returns/automation/dropoffAutoProcessCompensationMethods",
      file: "automation/processing/dropoff-auto-processing-section.tsx",
      sectionId: "returns.automation_dropoff_processing",
    },
    {
      id: "returns/automation/dropoffAutoProcessCompensationMethods",
      file: "returns/operations/processing/dropoff-auto-processing-rows.tsx",
      sectionId: "returns.automation_dropoff_processing",
    },
    {
      id: "returns/automation/inventory/restock",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/inventory/restock",
      file: "returns/operations/inventory/inventory-section.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/merchantCreatedReturns/enableBulkItemDetails",
      file: "returns/operations/merchant-created-returns/merchant-created-returns-section.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/enableMerchantReturnFlow",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/enableMerchantReturnFlow",
      file: "returns/operations/merchant-created-returns/merchant-created-returns-section.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedClaimsRequireShipping",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedClaimsRequireShipping",
      file: "returns/operations/merchant-created-returns/merchant-created-returns-section.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedReturnLabelChargeDefault",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedReturnLabelChargeDefault",
      file: "returns/operations/merchant-created-returns/merchant-created-returns-section.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/orderSyncArtifactId",
      file: "automation/code-functions-section.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/automation/orderSyncArtifactId",
      file: "returns/operations/processing/code-functions-rows.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/automation/returnAdjustmentArtifactId",
      file: "automation/code-functions-section.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/automation/returnAdjustmentArtifactId",
      file: "returns/operations/processing/code-functions-rows.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/automation/returnProcessing/exchange",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/exchange",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/exchangeDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/exchangeDelay",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refund",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refund",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refundDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refundDelay",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/requireImageForUndeclaredItems",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/requireImageForUndeclaredItems",
      file: "returns/warehouse/processing-section.tsx",
      sectionId: "returns.managed_returns_processing_flow",
    },
    {
      id: "returns/automation/returnProcessing/reviewAfterWarehouseProcessing",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/reviewAfterWarehouseProcessing",
      file: "returns/operations/processing/return-processing-rows.tsx",
    },
    {
      id: "returns/automation/returnProcessing/storeCredit",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/storeCredit",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/storeCreditDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/storeCreditDelay",
      file: "returns/operations/processing-events/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/shopify/addOrderNotes",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/addOrderNotes",
      file: "returns/operations/ecommerce/shopify/shopify-settings-section.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/addTrackingToShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/addTrackingToShopifyReturns",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/applyRestockingFeeToShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/applyRestockingFeeToShopifyReturns",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/archiveShopifyOrdersAfterReturn",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/archiveShopifyOrdersAfterReturn",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/closeShopifyReturnWhenProcessed",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/closeShopifyReturnWhenProcessed",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/createMultipleShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createMultipleShopifyReturns",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/createSeparateShopifyReturnForGreenReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createSeparateShopifyReturnForGreenReturns",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/createShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturns",
      file: "returns/operations/ecommerce/shopify/shopify-settings-section.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnsForClaimsAndWarranties",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnsForClaimsAndWarranties",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnTypes",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnTypes",
      file: "returns/operations/ecommerce/shopify/shopify-returns-rows.tsx",
    },
    {
      id: "returns/automation/shopify/disableRefundLineItems",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/disableRefundLineItems",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/disposeShopifyReverseFulfillmentOnRestock",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/disposeShopifyReverseFulfillmentOnRestock",
      file: "returns/operations/inventory/inventory-section.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEligibleCountries",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEligibleCountries",
      file: "returns/operations/ecommerce/shopify/duties-rows.tsx",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEnabled",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEnabled",
      file: "returns/operations/ecommerce/shopify/duties-rows.tsx",
    },
    {
      id: "returns/automation/shopify/giftCardRecipient",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/giftCardRecipient",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/automation/shopify/refundAllReturnedItems",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/refundAllReturnedItems",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/refundDutiesMode",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/refundDutiesMode",
      file: "returns/operations/ecommerce/shopify/duties-rows.tsx",
    },
    {
      id: "returns/automation/shopify/restockShopifyRefunds",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/restockShopifyRefunds",
      file: "returns/operations/inventory/inventory-section.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/shopify/shouldAutoProcessRedoReturnWhenShopifyReturnCloses",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/shouldAutoProcessRedoReturnWhenShopifyReturnCloses",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/showStoreCreditOnRefundNote",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/showStoreCreditOnRefundNote",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/skipEcommerceProviderRestock",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/skipEcommerceProviderRestock",
      file: "returns/operations/inventory/inventory-section.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/shopify/skipExchangeRefunds",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/skipExchangeRefunds",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationDays",
      file: "expire-store-credit.tsx",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationDays",
      file: "returns/operations/ecommerce/shopify/store-credit-expiration-rows.tsx",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationEnabled",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationEnabled",
      file: "returns/operations/ecommerce/shopify/store-credit-expiration-rows.tsx",
    },
    {
      id: "returns/automation/shopify/syncReturnFeesToShopify",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/syncReturnFeesToShopify",
      file: "returns/operations/ecommerce/shopify/refund-rows.tsx",
    },
    {
      id: "returns/automation/waiveRefundStoreCreditBelowAmount",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/waiveRefundStoreCreditBelowAmount",
      file: "returns/operations/processing/general-rows.tsx",
    },
    {
      id: "returns/barcode/bottomDisplayOption",
      file: "returns/labels/label-builder/barcode-rows.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/bottomDisplayOption",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/enabled",
      file: "returns/labels/label-builder/barcode-rows.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/enabled",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/height",
      file: "returns/labels/label-builder/barcode-rows.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/height",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/topDisplayOption",
      file: "returns/labels/label-builder/barcode-rows.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/topDisplayOption",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/width",
      file: "returns/labels/label-builder/barcode-rows.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/width",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/bulkReturns/collections",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/bulkReturns/hideQuantity",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/bundleRestockingType",
      file: "customer-portal/bundle-settings.tsx",
    },
    {
      id: "returns/bundleRestockingType",
      file: "returns/portal/bundles/bundle-rows.tsx",
    },
    {
      id: "returns/bundleReturnMode",
      file: "customer-portal/bundle-settings.tsx",
    },
    {
      id: "returns/bundleReturnMode",
      file: "returns/portal/bundles/bundle-rows.tsx",
    },
    {
      id: "returns/coverageExcludedVariantMetafields",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "returns/coverageExcludedVariantMetafields",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "returns/disableRejectedItems",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/exchanges/addTaxToExchangeOrders",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/addTaxToExchangeOrders",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/enabled",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/enabled",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/returnValueGateway",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/returnValueGateway",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/upsellGateway",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/upsellGateway",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/exchangeFinancialStrategy",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/exchangeFinancialStrategy",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/exchangeOrderLineItemPriceSource",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/exchangeOrderLineItemPriceSource",
      file: "returns/operations/orders/exchange-order-pricing-rows.tsx",
    },
    {
      id: "returns/exchanges/exchangeShippingName",
      file: "exchanges/cards/exchange-shipping-card.tsx",
      sectionId: "returns.exchanges_shipping_name",
    },
    {
      id: "returns/exchanges/exchangeShippingName",
      file: "returns/operations/orders/order-basics-rows.tsx",
    },
    {
      id: "returns/exchanges/fulfillment/excessExchangeValue",
      file: "exchanges/cards/fulfillment-card.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillment/excessExchangeValue",
      file: "returns/operations/processing/out-of-stock-rows.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillment/outOfStockAdvanced",
      file: "exchanges/cards/fulfillment-card.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillment/outOfStockAdvanced",
      file: "returns/operations/processing/out-of-stock-rows.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/defaultLocationIds",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/defaultLocationIds",
      file: "returns/operations/orders/fulfillment-regions-rows.tsx",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/enabled",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/enabled",
      file: "returns/operations/orders/fulfillment-regions-rows.tsx",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/regionMappings",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/regionMappings",
      file: "returns/operations/orders/fulfillment-regions-rows.tsx",
    },
    {
      id: "returns/exchanges/orderName/duplicateOrderNumberFormat",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/duplicateOrderNumberFormat",
      file: "returns/operations/orders/order-numbering-rows.tsx",
    },
    {
      id: "returns/exchanges/orderName/prefix",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/prefix",
      file: "returns/operations/orders/order-numbering-rows.tsx",
    },
    {
      id: "returns/exchanges/orderName/reuseOrderName",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/reuseOrderName",
      file: "returns/operations/orders/order-basics-rows.tsx",
    },
    {
      id: "returns/exchanges/orderName/shouldStripHash",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/shouldStripHash",
      file: "returns/operations/orders/order-basics-rows.tsx",
    },
    {
      id: "returns/exchanges/orderNotes/addNoteToOriginalOrders",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/addNoteToOriginalOrders",
      file: "returns/operations/orders/exchange-order-notes-rows.tsx",
    },
    {
      id: "returns/exchanges/orderNotes/disabled",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/disabled",
      file: "returns/operations/orders/exchange-order-notes-rows.tsx",
    },
    {
      id: "returns/exchanges/orderNotes/includeDate",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/includeDate",
      file: "returns/operations/orders/exchange-order-notes-rows.tsx",
    },
    {
      id: "returns/exchanges/orderNotes/includeExistingNote",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/includeExistingNote",
      file: "returns/operations/orders/exchange-order-notes-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/addAdditionalExchangeTags",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/addAdditionalExchangeTags",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItem",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItem",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItemName",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItemName",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/createTrigger",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/createTrigger",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/exchangeOrderCreationArtifactId",
      file: "automation/code-functions-section.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/exchanges/orders/exchangeOrderCreationArtifactId",
      file: "returns/operations/processing/code-functions-rows.tsx",
      sectionId: "returns.automation_code_functions",
    },
    {
      id: "returns/exchanges/orders/labelWaitForInvoice",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/labelWaitForInvoice",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/nonZeroValueExchangeStrategy",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/nonZeroValueExchangeStrategy",
      file: "returns/operations/orders/even-exchange-value-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/separateQuantityForExchangeProducts",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/separateQuantityForExchangeProducts",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/shopifyExchangeOrderStrategy",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/shopifyExchangeOrderStrategy",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    {
      id: "returns/exchanges/orders/shouldRemoveHoldTagWhenRelease",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/shouldRemoveHoldTagWhenRelease",
      file: "returns/operations/orders/advanced-orders-rows.tsx",
    },
    { id: "returns/finalSaleReturns/enabled", file: "coverage/coverage.tsx" },
    {
      id: "returns/finalSaleReturns/enabled",
      file: "returns/coverage/return-coverage/return-coverage-section.tsx",
      sectionId: "coverage.return_coverage",
    },
    {
      id: "returns/giftReceipts/emailNotifications",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/emailNotifications",
      file: "returns/portal/gift-returns/advanced-gift-returns-rows.tsx",
    },
    {
      id: "returns/giftReceipts/enabled",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/enabled",
      file: "returns/portal/gift-returns/gift-returns-rows.tsx",
    },
    {
      id: "returns/giftReceipts/missingBuyerInfoDescription",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/missingBuyerInfoDescription",
      file: "returns/portal/gift-returns/gift-returns-rows.tsx",
    },
    {
      id: "returns/giftReceipts/notificationEmails",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/notificationEmails",
      file: "returns/portal/gift-returns/advanced-gift-returns-rows.tsx",
    },
    {
      id: "returns/giftReceipts/requireShopperEmailAndGiftInformation",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/requireShopperEmailAndGiftInformation",
      file: "returns/portal/gift-returns/advanced-gift-returns-rows.tsx",
    },
    {
      id: "returns/itemDisposition/enabled",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/enabled",
      file: "returns/warehouse/grade-actions/grade-actions-section.tsx",
      sectionId: "returns.warehouse_grade_actions",
    },
    {
      id: "returns/itemDisposition/gradeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/gradeOptions",
      file: "returns/warehouse/grade-actions/grade-list-rows.tsx",
    },
    {
      id: "returns/itemDisposition/outcomeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/outcomeOptions",
      file: "returns/warehouse/grade-actions/grade-list-rows.tsx",
    },
    {
      id: "returns/manualReviewOnMissingCustoms",
      file: "international/components/missing-customs-review-section.tsx",
      sectionId: "international_returns.missing_customs_review",
    },
    {
      id: "returns/merchantCarrierReturnLabels/carrierAccountDisabledServiceLevels",
      file: "carrier-accounts/merchant-carriers.tsx",
    },
    {
      id: "returns/permissions/allowEditFeesAndBonuses",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditFeesAndBonuses",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditGreenReturns",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditGreenReturns",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditReturn",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditReturn",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowExchange",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowExchange",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowRefund",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowRefund",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowStoreCredit",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowStoreCredit",
      file: "returns/operations/merchant-created-returns/staff-permissions-rows.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/processing/allowRestockBeforeProcess",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/allowRestockBeforeProcess",
      file: "returns/operations/inventory/inventory-section.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/processing/checkForTryNowTags",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/checkForTryNowTags",
      file: "returns/operations/processing/return-processing-rows.tsx",
    },
    {
      id: "returns/processing/disableRiseCreditEmail",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/disableRiseCreditEmail",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/giftCardOrderProductId",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/giftCardOrderProductId",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/hideGiftCardBranding",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/hideGiftCardBranding",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/riseTriggerUrl",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/riseTriggerUrl",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/shopAgainAction",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/shopAgainAction",
      file: "returns/operations/processing/store-credit-rows.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/redoAssistedCustoms/customsDescriptionOptOut",
      file: "international/components/product-catalog-readiness-card.tsx",
      sectionId: "international_returns.redo_assisted_customs",
    },
    {
      id: "returns/redoAssistedCustoms/hsCodeOptOut",
      file: "international/components/product-catalog-readiness-card.tsx",
      sectionId: "international_returns.redo_assisted_customs",
    },
    {
      id: "returns/returnEditing/allowCustomerCancelReturn",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnEditing/allowCustomerCancelReturn",
      file: "returns/portal/return-editing-section.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnEditing/allowCustomerEditExchangeAddress",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnEditing/allowCustomerEditExchangeAddress",
      file: "returns/portal/return-editing-section.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnsCoverageExcludedSkus",
      file: "coverage/coverage.tsx",
    },
    {
      id: "returns/returnsCoverageExcludedSkus",
      file: "returns/coverage/return-coverage/exclusion-rows.tsx",
    },
    {
      id: "returns/returnTogether",
      file: "returns/portal/bundles/bundle-rows.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessEnabled",
      file: "returns/labels/label-builder/label-content-rows.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessText",
      file: "returns/labels/label-builder/label-content-rows.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessText",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/carrierChoiceMaxMerchantPaidAmount",
      file: "returns/operations/shipping-options/carrier-choice-rows.tsx",
    },
    {
      id: "returns/shipping/carrierChoiceMaxMerchantPaidAmount",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/carrierChoiceMaxShownAmount",
      file: "returns/operations/shipping-options/carrier-choice-rows.tsx",
    },
    {
      id: "returns/shipping/carrierChoiceMaxShownAmount",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/customerLabelUpchargeFee",
      file: "returns/policies/workflows-section.tsx",
      sectionId: "returns.policies_workflows",
    },
    {
      id: "returns/shipping/customerLabelUpchargeFee",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/customInStoreLocations",
      file: "returns/locations/return-locations/in-store-location-rows.tsx",
    },
    {
      id: "returns/shipping/customInStoreLocations",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromCredit",
      file: "returns/portal/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/deductLabelFromCredit",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromExchange",
      file: "returns/portal/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/deductLabelFromExchange",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromRefund",
      file: "returns/portal/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/deductLabelFromRefund",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/dontChargeCustomerLabelUpchargeWhenOnlyOption",
      file: "returns/policies/workflows-section.tsx",
      sectionId: "returns.policies_workflows",
    },
    {
      id: "returns/shipping/dontChargeCustomerLabelUpchargeWhenOnlyOption",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/dropoffs",
      file: "returns/locations/dropoff-providers-section.tsx",
      sectionId: "returns.shipping_dropoff_providers",
    },
    {
      id: "returns/shipping/dropoffs",
      file: "shipping/sections/dropoff-providers-section.tsx",
    },
    {
      id: "returns/shipping/excludeCustomerLabelFeeForExchanges",
      file: "returns/policies/workflows-section.tsx",
      sectionId: "returns.policies_workflows",
    },
    {
      id: "returns/shipping/excludeCustomerLabelFeeForExchanges",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/formLabelInstructions",
      file: "returns/labels/label-builder/instruction-rows.tsx",
    },
    {
      id: "returns/shipping/formLabelInstructions",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/ignoreTeamCarrierOverrideInMerchantDash",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/ignoreTeamCarrierOverrideInMerchantDash",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/includeExchangeItemsOnPackingSlip",
      file: "returns/labels/packing-slip/packing-slip-builder-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/includeExchangeItemsOnPackingSlip",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/inStoreDropOffPackingSlipEnabled",
      file: "returns/labels/packing-slip/packing-slip-builder-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/inStoreDropOffPackingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/inStoreLocations",
      file: "returns/locations/return-locations/in-store-location-rows.tsx",
    },
    {
      id: "returns/shipping/inStoreLocations",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/labelCustomText",
      file: "returns/labels/label-builder/label-text-rows.tsx",
    },
    {
      id: "returns/shipping/labelCustomText",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/labelIncludeReturnType",
      file: "returns/labels/label-builder/label-content-rows.tsx",
    },
    {
      id: "returns/shipping/labelIncludeReturnType",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/labelRmaBarcodeEnabled",
      file: "returns/labels/label-builder/label-content-rows.tsx",
    },
    {
      id: "returns/shipping/labelRmaBarcodeEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/manualLabelPackingSlipEnabled",
      file: "returns/labels/packing-slip/packing-slip-builder-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/manualLabelPackingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/merchantMaxLabelPrice",
      file: "returns/policies/workflows-section.tsx",
      sectionId: "returns.policies_workflows",
    },
    {
      id: "returns/shipping/merchantMaxLabelPrice",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/onlyCombineLabelsFromSameFulfillment",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/onlyCombineLabelsFromSameFulfillment",
      file: "returns/labels/labels-flow/advanced-labels-flow-rows.tsx",
    },
    {
      id: "returns/shipping/packingInstructions",
      file: "returns/labels/packing-slip/packing-instruction-rows.tsx",
    },
    {
      id: "returns/shipping/packingInstructions",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/packingSlipEnabled",
      file: "returns/labels/packing-slip/packing-slip-builder-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/packingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmount",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmount",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmountEnabled",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmountEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureEnabled",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsEnabled",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsTags",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsTags",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureThreshold",
      file: "returns/operations/shipping-options/shipping-options-section.tsx",
      sectionId: "returns.shipping_options",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureThreshold",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/returnInStoreEnabled",
      file: "returns/locations/return-locations/in-store-drop-off-rows.tsx",
    },
    {
      id: "returns/shipping/returnInStoreEnabled",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/returnInStoreRadiusMiles",
      file: "returns/locations/return-locations/in-store-drop-off-rows.tsx",
    },
    {
      id: "returns/shipping/returnInStoreRadiusMiles",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/skuGroupingCsvFileUrl",
      file: "flows/sku-grouping-csv-upload.tsx",
    },
    {
      id: "returns/shipping/skuGroupingEnabled",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/skuGroupingEnabled",
      file: "returns/labels/labels-flow/advanced-labels-flow-rows.tsx",
    },
    {
      id: "returns/shipping/verifyAddressForLabel",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/verifyAddressForLabel",
      file: "returns/labels/label-builder/advanced-label-builder-rows.tsx",
    },
    {
      id: "returns/shopifyCustomsMetafields/descriptionKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/manufacturerKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/manufacturerPartNumberKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/materialKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantDescriptionKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantManufacturerKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantManufacturerPartNumberKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantMaterialKey",
      file: "international/components/international-metafields-form.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/ui/aiReviewDefaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/aiReviewDefaultCollapsed",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/defaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/defaultCollapsed",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/exposeExternalId",
      file: "returns-ui/external-ra-number-card.tsx",
      sectionId: "returns.ui_external_ra_number",
    },
    {
      id: "returns/ui/exposeExternalId",
      file: "returns/operations/processing/general-rows.tsx",
    },
    {
      id: "returns/ui/lineItemDetailOptions",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/lineItemDetailOptions",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/productMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/productMetafieldDisplays",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/variantMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/variantMetafieldDisplays",
      file: "returns/operations/return-page-display/return-page-display-section.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/useShopifyNativeBundles",
      file: "customer-portal/bundle-settings.tsx",
    },
    {
      id: "returns/useShopifyNativeBundles",
      file: "returns/portal/bundles/bundle-rows.tsx",
    },
    {
      id: "returns/warehouse/gradeMappings",
      file: "managed-returns/returns-centers-index.tsx",
      sectionId: "returns.warehouse_grade_actions",
    },
    {
      id: "returns/warehouse/gradeMappings",
      file: "returns/warehouse/grade-actions/grade-actions-section.tsx",
      sectionId: "returns.warehouse_grade_actions",
    },
    {
      id: "returns/withdrawals/enabled",
      file: "withdrawals/withdrawals-general-section.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/enableMerchantWithdrawalSubmittedEmail",
      file: "withdrawals/withdrawals-notifications-section.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/enablethirdPartyFulfillmentCancellationEmail",
      file: "withdrawals/withdrawals-notifications-section.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/excludedCollections",
      file: "withdrawals/withdrawals-exclusions-section.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/excludedMetafields",
      file: "withdrawals/withdrawals-exclusions-section.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/excludedProductTags",
      file: "withdrawals/withdrawals-exclusions-section.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/hourDelayForAutoCancellation",
      file: "withdrawals/withdrawals-auto-cancellation-section.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/lateWithdrawalNoticeText",
      file: "withdrawals/withdrawals-auto-cancellation-section.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/merchantEmailsForNotifications",
      file: "withdrawals/withdrawals-notifications-section.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/preventAutoCancellingUnfulfilledOrder",
      file: "withdrawals/withdrawals-auto-cancellation-section.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/shippingRefundFixedAmount",
      file: "withdrawals/withdrawals-general-section.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/shippingRefundMode",
      file: "withdrawals/withdrawals-general-section.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/tagsToAddToAutoCancelledOrders",
      file: "withdrawals/withdrawals-general-section.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/tagsToBlockAutoCancellation",
      file: "withdrawals/withdrawals-auto-cancellation-section.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/thirdPartyFulfillmentCancellationEmailList",
      file: "withdrawals/withdrawals-notifications-section.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "shopifyExtension/coverageExcludePickup",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.general_coverage",
    },
    {
      id: "shopifyExtension/coverageExcludePickup",
      file: "returns/coverage/return-coverage/advanced-return-coverage-rows.tsx",
    },
    {
      id: "shopifyExtension/deleteCartProperties",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopifyExtension/deleteCartProperties",
      file: "returns/coverage/package-protection/shopify-function-rows.tsx",
      sectionId: "coverage.advanced_coverage",
    },
    {
      id: "shopifyExtension/digitalWarehouse/enabled",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.digital_warehouse",
    },
    {
      id: "shopifyExtension/digitalWarehouse/enabled",
      file: "returns/coverage/package-protection/digital-warehouse-rows.tsx",
      sectionId: "coverage.digital_warehouse",
    },
    {
      id: "shopifyExtension/displayIcon",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerInsertBeforeBody",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerInsertBeforeBody",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerPositionBottom",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerPositionBottom",
      file: "returns/portal/exchange-ui/exchange-banner-rows.tsx",
    },
    { id: "shopifyExtension/icon", file: "coverage/cart-item-settings.tsx" },
    {
      id: "shopifyExtension/iconBackgroundColor",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "shopifyExtension/iconColor",
      file: "coverage/cart-item-settings.tsx",
    },
    { id: "shopifyExtension/logo", file: "coverage/cart-item-settings.tsx" },
    {
      id: "shopifyExtension/redoProductImage",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "support/ai/aiAutopilotTicketVolume",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/autoCloseNoReplyTickets",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/autoGenerateResponses",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/automateLiveChat",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/autopilotEnabled",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/copilotEnabled",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/enabledPlatforms/attentive",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/email",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/facebook",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/facebookComments",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/instagram",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/instagramComments",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/postscript",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/sms",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/enabledPlatforms/tiktok",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai_channels",
    },
    {
      id: "support/ai/respondToInternalEmails",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/whitelistedDomains",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/ai/whitelistedEmails",
      file: "ai-agent/components/general-ai-support-tab.tsx",
      sectionId: "support.ai",
    },
    {
      id: "support/csat/abTestEnabled",
      file: "customer-satisfaction/panels/ab-test-settings.tsx",
    },
    {
      id: "support/csat/abTestVariants",
      file: "customer-satisfaction/panels/ab-test-settings.tsx",
    },
    {
      id: "support/csat/allowedInboxEmails",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/allowRemarks",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/emailTemplateId",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/enabled",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/headerImage",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/sampleRate",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/surveyMessage",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/surveyMethods",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/surveySendTime",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    { id: "support/tags", file: "conversation-tags/tag-group-card.tsx" },
    {
      id: "support/tags",
      file: "conversation-tags/tags.tsx",
      sectionId: "support.tags",
    },
    { id: "support/unassignOpenTicketsAtShiftEnd", file: "ticket-rules.tsx" },
    {
      id: "teamworkCommerce/processing/customOrders/manualReviewPaymentGateways",
      file: "teamwork-commerce-settings/teamwork-custom-order-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/customOrders/paymentGateways",
      file: "teamwork-commerce-settings/teamwork-custom-order-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/customOrders/refundDocument",
      file: "teamwork-commerce-settings/teamwork-custom-order-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/enabled",
      file: "teamwork-commerce-settings/teamwork-commerce-processing-section.tsx",
      sectionId: "integrations.teamwork-commerce",
    },
    {
      id: "teamworkCommerce/processing/receipt",
      file: "teamwork-commerce-settings/teamwork-receipt-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/storeCredit/giftCards",
      file: "teamwork-commerce-settings/teamwork-gift-card-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/storeCredit/issuer",
      file: "teamwork-commerce-settings/teamwork-store-credit-section.tsx",
    },
    {
      id: "teamworkCommerce/processing/worksheet",
      file: "teamwork-commerce-settings/teamwork-worksheet-section.tsx",
    },
    {
      id: "warranties/allowQuantitySelect",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/askShopperForPricePaid",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/cantFindItemButtonEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/mailingListSignUpEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/contact-information/contact-information-page-customization-panel.tsx",
    },
    {
      id: "warranties/maxQuantitySelect",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/purchaseChannelRegistrationCollection",
      file: "registration-settings.tsx",
      sectionId: "warranty_registration.registration_collections",
    },
    {
      id: "warranties/purchaseChannels",
      file: "registration-settings.tsx",
      sectionId: "warranty_registration.purchase_channels",
    },
    {
      id: "warranties/registrationRewardDiscountId",
      file: "registration-rewards.tsx",
      sectionId: "warranty_registration_rewards.discount",
    },
    {
      id: "warranties/showOtherOption",
      file: "customer-portal-builder/left-panel/settings/pages/purchase-channel/purchase-channel-page-customization-panel.tsx",
    },
  ],
};
